import { IsSanitizedHtml } from "@wog/mol-lib-api-contract/utils";
import { Transform } from "class-transformer";
import { IsEnum, IsNumber, IsOptional, IsString } from "class-validator";
import moment from "moment";
import { IsMoment } from "../../../validators";
import { HTTP_VERBS } from "../../enums";
import { TrustedPersonDO } from "../domainObjects";
import { toMoment, toNumber } from "./../../transformers";
import { InvitationOrigin } from "../enums";

export const httpVerb = HTTP_VERBS.POST;
export const url = "/api/users/trustedpersons";
export class Body extends TrustedPersonDO {
	@IsOptional()
	@IsEnum(InvitationOrigin)
	origin?: InvitationOrigin;
}
export class Response {
	@IsNumber()
	@Transform(toNumber)
	public id!: number;

	@IsString()
	@IsSanitizedHtml({ sanitizeHtmlOptions: { allowedTags: [] } })
	public nric!: string;

	@IsString()
	@IsSanitizedHtml({ sanitizeHtmlOptions: { allowedTags: [] } })
	public nickname!: string;

	@IsOptional()
	@IsString()
	@IsSanitizedHtml({ isOptional: true, sanitizeHtmlOptions: { allowedTags: [] } })
	public email!: string;

	@IsOptional()
	@IsString()
	@IsSanitizedHtml({ isOptional: true, sanitizeHtmlOptions: { allowedTags: [] } })
	public phone!: string;

	@IsMoment()
	@Transform(toMoment)
	public invitedOn!: moment.Moment;

	@IsNumber()
	@Transform(toNumber)
	public inviteAttemptsLeft!: number;
}
